import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import Home from './Home'
import { update } from '@src/redux/modules/bookingSetup'
import { logout, isLoggedIn } from '@src/redux/modules/auth'

const mapStateToProps = (state) => {
  return {
    loggedIn: isLoggedIn(state)
  }
}

const mapDispatchToProps = {
  update,
  push,
  logout
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Home/HomeContainer.js